import ElementContentCollectionBanner from '@/components/sections/builder/elements/body/collection-banner/content';
import ElementSettingCollectionBanner from '@/components/sections/builder/elements/body/collection-banner/setting';
import { CollectionBannerElementDataType } from '@/components/sections/builder/elements/body/collection-banner/type';
import { BetweenHorizontalStart } from 'lucide-react';

const defaultData: CollectionBannerElementDataType = {
  name: 'Collection Banner',
  isShowDescription: true,
  isShowImage: true,
  bannerStyle: 'box',
  bannerHeight: 400,
};

export const ElementPreviewIcon = BetweenHorizontalStart;

const CollectionBanner = {
  type: 'collection_banner',
  group: 'body_collections',
  defaultData,
  Element: ElementContentCollectionBanner,
  Setting: ElementSettingCollectionBanner,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [],
  childs: [],
};

export default CollectionBanner;
